import { render, staticRenderFns } from "./BranchesContact.vue?vue&type=template&id=67924125&scoped=true&"
import script from "./BranchesContact.vue?vue&type=script&lang=js&"
export * from "./BranchesContact.vue?vue&type=script&lang=js&"
import style0 from "./BranchesContact.vue?vue&type=style&index=0&id=67924125&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67924125",
  null
  
)

export default component.exports